import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import http from './config/http';
import router from './router/index';
import store from './store';
// import 'default-passive-events';
Vue.config.productionTip = false

Vue.use(ElementUI);

// 注册自定义组件(全局组件)
import CTable from "./components/CTable/index.vue";
Vue.component("CTable", CTable);
import CForm from "./components/CForm/index.vue";
Vue.component("CForm", CForm);
import CFormItem from "./components/CForm/CFormItem.vue";
Vue.component("CFormItem", CFormItem);
import CSearch from "./components/CSearch/index.vue";
Vue.component("CSearch", CSearch);
import TableBtns from "./components/TableBtns/index.vue";
Vue.component("TableBtns", TableBtns);
import CTitle from "@/components/CTitle";
Vue.component("CTitle", CTitle);
import CGrid from "@/components/CGrid";
Vue.component("CGrid", CGrid);
import CCollapseItem from "./components/CCollapseItem/index.vue";
Vue.component("CCollapseItem", CCollapseItem);
import CDescription from "./components/CDescription/index.vue";
Vue.component("CDes", CDescription);
import BackToPrePage from "./components/BackToPrePage/index.vue";
Vue.component("BackToPrePage", BackToPrePage);

// 自定义拖动指令
Vue.directive('drag', function (el) {
  el.onmousedown = function (e) {
    var disx = e.clientX - el.offsetLeft;
    var disy = e.clientY - el.offsetTop;
    document.onmousemove = function (e) {
      el.style.left = e.clientX - disx + 'px';
      el.style.top = e.clientY - disy + 'px';
    }
    document.onmouseup = function () {
      document.onmousemove = document.onmouseup = null;
    }
  }
});

Vue.prototype.$http = http;


new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
